'use client';
import useRestaurantAuth from '@/hooks/useRestaurantAuth';
import { useEffect } from 'react';

/**
 * This component for redirect if user is logged in
 *
 * @returns null
 */
export default function RestaurantAuthRedirect() {
  const { checkRestaurantAuthAndRedirect } = useRestaurantAuth();

  useEffect(() => {
    checkRestaurantAuthAndRedirect();
  }, []);

  return null;
}
